import React from "react";

import { Skeleton } from "@formant/ui-kit";

export const OverviewSkeletonLoader = () => {
    return (
        <div className="h-full">
            <div className="flex gap-4 p-4 " style={{ height: "500px" }}>
                <Skeleton className="h-full w-1/2 " />
                <Skeleton className="h-full w-1/2 " />
            </div>
            <div className="flex gap-4 p-4 " style={{ height: "500px" }}>
                <Skeleton className="h-full w-1 " />
                {/* <Skeleton className="h-full w-1/2 " /> */}
            </div>
        </div>
    );
};
